import { IArtifactComponentProps } from "types/services";
import { IExteriorPropertyDetailsArtifact } from "types/artifacts/exterior-property-details";
import { IPropertyId } from "types/artifacts/common";
import { ExteriorOrInteriorOrRoomCard } from "components/ExteriorOrInteriorOrRoomCard";
import { findArtifactByHarid, haridMatches } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IExteriorPropertyDetailsOutputProps = IArtifactComponentProps<
    IPropertyId,
    IExteriorPropertyDetailsArtifact
>;

ExteriorPropertyDetailsOutput.artifactKey = "property_detail";

export function ExteriorPropertyDetailsOutput(props: IExteriorPropertyDetailsOutputProps): JSX.Element {
    const { harid, artifacts = [] } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (harid) {
        const artifactsCount = artifacts.length;
        const artifact = artifactsCount > 1 ? artifacts.find((x) => haridMatches(x.harid, harid) && (x?.select_fields && Array.isArray(x?.select_fields) ? x.select_fields : [])[0] === "exterior") : findArtifactByHarid(artifacts, harid);
        const exterior = artifact?.response?.exterior;
        const { artifact_text, ...remainingExteriorProperties } = exterior || {};
        if (artifact && exterior) {
            return (
                <div className="mb-md-4 mb-3 without-ad" style={{ width: '98%' }}>
                    <h2>Exterior</h2>
                    <ExteriorOrInteriorOrRoomCard data={remainingExteriorProperties} />
                </div>
            );
        }

        console.error(
            "No artifact or exterior found for 'ExteriorPropertyDetailsOutput' with the given harid:",
            harid
        );

        return <></>;
    }

    console.error(
        "No harid provided for 'ExteriorPropertyDetailsOutput'."
    );

    return <></>;

}

ExteriorPropertyDetailsOutput.asText = function (props: IExteriorPropertyDetailsOutputProps): string {
    // console.log("ExteriorPropertyDetailsOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.exterior?.artifact_text || "" : isProduction ? "" : "ExteriorPropertyDetailsOutput asText Not Implemented!";
}
